import { render, staticRenderFns } from "./QuizProgress.vue?vue&type=template&id=2794179f"
import script from "./QuizProgress.vue?vue&type=script&lang=js"
export * from "./QuizProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports